import type { GridOptions, GridSideBarOptions, GridSideBarResolved } from '../types'

const DEFAULT_SIDE_BAR: GridSideBarResolved = {
  enabled: true,
  defaultOpen: false,
  position: 'right',
  width: 720,
  draggable: true,
  liveUpdate: false,
  maxFixedCount: 4,
}

export function resolveSideBarOptions(options: GridOptions): GridSideBarResolved {
  const raw = options.sideBar
  if (raw === false) {
    return { ...DEFAULT_SIDE_BAR, enabled: false }
  }
  if (raw === true || raw == null) {
    return { ...DEFAULT_SIDE_BAR }
  }
  return {
    ...DEFAULT_SIDE_BAR,
    ...raw,
    enabled: raw.enabled !== false,
  }
}

export function isSideBarEnabled(options: GridOptions) {
  return resolveSideBarOptions(options).enabled
}
